module.exports = __webpack_public_path__ + "img/tarj1-1.1d0ab781.svg";